import { Component, OnInit } from '@angular/core';
import { Avatar, UserService } from 'projects/core/src/lib/login/data/user.service';



@Component({
    selector: 'app-avatars-test',
    templateUrl: './avatars-test.component.html',
    styleUrls: ['./avatars-test.component.scss']
})
export class AvatarsTestComponent implements OnInit {

    avaArr: Avatar[] = [];

    constructor(
        protected userService: UserService
    ) { }

    ngOnInit() {
        // this.userService.getAllAvatars().subscribe(avas => this.avaArr = avas)
        for (let i = 0; i < 1650; i++) {
            this.avaArr.push({
                shortCode: this.random(2),
                bgColor: this.randomColor(6)
            })
        }
    }

    random(length) {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    randomColor(length) {
        let result = '';
        const characters = 'abcdef0123456789';
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

}
